<template>
  <div id="chat-wrapper" :style="`
    top: ${top}px; 
    left: ${left}px; 
    width: ${width}px; 
    height: ${height}px`">
    <div id="chat-handle"
      @mousedown="moving = true"
      @mouseup="moving = false"
      @mouseleave="moving = false"
      @mousemove="handleMove">
      chat
    </div>
    <div id="chat-messages-wrapper">
      <div 
        class="chat-message" 
        v-for="message in [].concat(messages).reverse()" 
        :key="message">
        <span class="server-message" v-if="message.startsWith('server: ')">
          {{ message.replace('server: ', '') }}
        </span>
        <span v-else>
          {{ message }}
        </span>
      </div>
    </div>
    <div id="chat-input-wrapper">
      <input v-model="chatMessage" @keyup.enter="sendMessage()" />
      <button @click="sendMessage()">send</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatWindow',
  props: ['socket'],
  data () {
    return {
      messages: [],
      chatMessage: '',
      moving: false,
      top: 100,
      left: 0,
      width: 400,
      height: 600
    }
  },
  methods: {
    sendMessage () {
      this.socket.emit('message', this.chatMessage);
      this.chatMessage = '';
    },
    handleMove (e) {
      if (!this.moving) return;
      this.top += e.movementY;
      this.left += e.movementX;
      this.width = parseInt(this.$el.style.width);
      this.height = parseInt(this.$el.style.height);
    }
  },
  mounted () {
    this.socket.emit('bump-messages');

    this.socket.on('messages', messages => {
      this.messages = messages;
    });

    this.socket.on('get-ping', callback => {
      callback();
    });
  }
}
</script>

<style scoped>
#chat-wrapper {
  width: 20%;
  height: 60%;
  background-color: rgba(0, 0, 0, .2);

  position: absolute;
  top: 20%;
  left: 0px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  overflow: hidden;
  resize: both;
}

#chat-messages-wrapper {
  width: calc(100% - 32px);
  height: 100%;
  background-color: rgba(0, 0, 0, .2);
  padding: 16px;
  overflow-y: auto;

  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  align-items: flex-start;
}

#chat-input-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

#chat-input-wrapper input {
  width: 100%;
}

#chat-handle {
  width: 100%;
  background-color: grey;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-message {
  width: 100%;
  word-wrap: break-word;
}

.server-message {
  color: blueviolet;
}
</style>